const VIDEO_TYPE = "wix-draft-plugin-video";
const videoButtonsTypes = { video: "video", youTube: "youTube" };
export {
  VIDEO_TYPE,
  videoButtonsTypes
};
//# sourceMappingURL=types.js.map
